// src/pages/ServiceAccountLedger/components/ServiceAccountLedgerFilters.js
import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import { Card, Row, Col, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../ServiceAccountLedgerSlice";
import {
  fetchServiceAccountLedger,
  fetchServiceAccountsBySearch,
} from "../ServiceAccountLedgerThunk";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import RecordDateFilter from "../../../../components/filters/RecordDateFilter";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";
import CommonDateRangeFilter from "../../../../components/common/filters/CommonDateRangeFilter";

const ServiceAccountLedgerFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.serviceAccountLedger);
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  useDefaultDateRange(setFilters, filters, "today");

  // Drill-down from Balance Sheet: /reports/service-ledger/<toDate>?fromDate=<fromDate>
  // Pre-fills the period; user selects the service account and runs the report.
  useEffect(() => {
    const path = pathname.split("/")[3];
    if (path) {
      const fromDate = searchParams.get("fromDate");
      const patch = { toDate: path };
      if (fromDate) patch.fromDate = fromDate;
      dispatch(setFilters(patch));
    }
  }, []);

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const searchAccount = useCallback(
    (text) => dispatch(fetchServiceAccountsBySearch(text)),
    [dispatch]
  );

  const handleReport = () => {
    if (!filters.accId) {
      messageApi.warning("Select Account");
      return;
    }

    dispatch(fetchServiceAccountLedger({ filters })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch records ❌");
      }
    });
  };

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={[16, 16]} align="middle">
        <Col xs={24} sm={12} md={12} lg={6}>
          <label>Search Account</label>
          <SearchListAutoComplete
            entityType="service_account"
            searchThunk={searchAccount}
            resultSelector={(state) =>
              state.serviceAccountLedger.serviceAccounts
            }
            onSelect={(obj) => {
              if(!obj) {
                handleFilterChange("accId", null);
                return;
              } 
              handleFilterChange("accId", obj?.sale_id);
            }}
            placeholder="Search Account"
            showAddNew={false}
          />
        </Col>

        <CommonDateRangeFilter
        filters={filters}
        onChange={(fromDate, toDate) => {
        handleFilterChange("fromDate", fromDate);
        handleFilterChange("toDate", toDate);
        }}
      />

        <Col
          xs={24}
          sm={12}
          md={12}
          lg={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            style={{height: 35.19}}
            block
          >
            Get Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default ServiceAccountLedgerFilters;
